var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[(_vm.isAuthenticating)?_c('checkout-authentication',{attrs:{"initialAuthType":_vm.initialAuthType,"isInsideDialog":_vm.isInsideDialog}}):_c('div',{staticClass:"checkout-container"},[_c('checkout-purchase',{attrs:{"isInsideDialog":_vm.isInsideDialog,"offer":_vm.offer}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }